import React, { useContext } from 'react'

import Cookies from 'js-cookie'
import { Navigate } from 'react-router-dom'

import { getUserOrganisationIds, UserContext } from '@acre/utils'

import usePermissionResolution from '@broker-crm-common/Permission/usePermissionResolution'

import { checkIfFirstTimeUser } from '../pages/Onboarding/Onboarding.helpers'

export const RedirectOnRoot = () => {
  const user = useContext(UserContext)

  const { isInitialCallComplete, gates } = usePermissionResolution({
    inputs: [
      {
        gates: ['VIEW_CASE_COMPLIANCE'],
        entityIdsCollection: {
          organisation: user ? getUserOrganisationIds({ user }).all : [],
        },
      },
      {
        gates: ['EDIT_CASE'],
        entityIdsCollection: {
          organisation: user ? getUserOrganisationIds({ user }).all : [],
        },
      },
    ],
    skip: !user,
  })

  if (!isInitialCallComplete) {
    return null
  }

  const redirect = Cookies.get('login_redirect')

  const isComplianceUser = gates.includes('VIEW_CASE_COMPLIANCE') && !gates.includes('EDIT_CASE')

  const { isFirstTimeUsingAcre } = checkIfFirstTimeUser(user)

  if (redirect) {
    Cookies.remove('login_redirect')
  }

  let path = '/cases/compliance-view'

  if (isFirstTimeUsingAcre) {
    path = '/welcome'
  } else if (!isComplianceUser) {
    path = redirect || '/cases/board-view'
  }

  return <Navigate to={path} />
}
